export default __webpack_public_path__ + "static/media/akda.9ebaedbd.svg";